import { ClipboardList, FileText, FormInput } from 'lucide-react';

export interface Panel {
  id: string;
  label: string;
  icon: React.ElementType;
}

export const ALL_PANELS: Panel[] = [
  { id: 'fax', label: 'Fax', icon: FileText },
  { id: 'input', label: 'Input', icon: FormInput },
  { id: 'output', label: 'Output', icon: ClipboardList },
];

export interface FaxSummaryViewProps {
  pdfUrl: string | null;
  InputColumn: React.ReactNode;
  OutputColumn: React.ReactNode;
}
